import { configureStore, combineReducers } from '@reduxjs/toolkit';
import WindReducer, { reducerName as windReducerName } from './WindStore';
import DocumentReducer, { reducerName as documentReducerName } from './DocumentStore';
import AuthReducer, { reducerName as authReducerName } from './AuthStore';
import StoryReducer, { reducerName as storyReducerName } from './StoryStore';
import DeviceReducer, { reducerName as deviceReducerName } from './DeviceStore';
import PauseReducer, { reducerName as pauseReducerName } from './PauseStore';
import WeatherReducer, { reducerName as weatherReducerName } from './WeatherStore';
import InstructionReducer, { reducerName as instructionReducerName } from './InstructionStore';

const rootReducer = combineReducers({
    [windReducerName]: WindReducer,
    [documentReducerName]: DocumentReducer,
    [authReducerName]: AuthReducer,
    [storyReducerName]: StoryReducer,
    [deviceReducerName]: DeviceReducer,
    [weatherReducerName]: WeatherReducer,
    [pauseReducerName]: PauseReducer,
    [instructionReducerName]: InstructionReducer,
});

export default function configureAppStore(preloadedState) {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        devTools: process.env.NODE_ENV === 'development',
    });
}